export default "__VITE_ASSET__DRElLCLl__"